export const FEATURE_ACTIVATION_APIS = {
  GET_FLAGS: "host/flag/features",
};
